import { atom } from 'jotai';
import { HSAformData } from 'types';
// TYPES

// Default/initial value for the atom
const initialHSAData: HSAformData = {
  customer_id: '',
  agency: '',
  client: '',
  line_of_business: '',
  market: '',
  region: '',
  platform: [''],
  status: '',
  new_business: false,
  hsa_status: 'No',
  platforms: [false, false, false, false],
  account_configurations: [],
  hsa_id: undefined,
  brand_signifiers: { filters: [] },
  whitelisted_domains: [],
  prelim_start_date: '',
  prelim_end_date: '',
  created_at: '',
  updated_at: '',
  updated_by: undefined,
};

export const selectedCustomerAtom = atom<HSAformData>(initialHSAData);
export const resetCustomerAtom = atom(null, (_get, set) =>
  set(selectedCustomerAtom, initialHSAData)
);
